import { render, staticRenderFns } from "./RankTable.vue?vue&type=template&id=934ace3a&"
import script from "./RankTable.vue?vue&type=script&lang=js&"
export * from "./RankTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports